import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, Typography } from '@material-ui/core';
import moment from 'moment-timezone';
import React, { useCallback, useEffect, useState } from 'react';
import { getCommentReports } from '../../../services/api/Moderation';
import { getStoryById } from '../../../services/api/Story';
import { IComment, ICommentReport, IStory } from '../../../services/types';
import useStyles from './CommentReportViewer.styles';
import CommentUser from './CommentUser';

interface IProps {
  comment?: IComment;
  onClose: () => void;
}

const RowsPerPage = 10;

const ReportViewer = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { comment, onClose } = props;
  const commentId = comment?.id;
  const reportedStoryId = comment?.storyId;

  const [reports, setReports] = useState<ICommentReport[]>([]);
  const [page, setPage] = useState<number>(0);
  const [totalCount, setTotalCount] = useState<number>(0);
  const [reportedStory, setReportedStory] = useState<IStory>();

  const handlePageChange = useCallback((e: unknown, page: number) => {
    setPage(page);
  }, []);

  const fetchReports = useCallback(async () => {
    if (!commentId || !reportedStoryId) {
      return;
    }

    const [{ data: comment }, { data: story }] = await Promise.all([
      getCommentReports(commentId, page + 1, RowsPerPage),
      getStoryById(reportedStoryId),
    ]);

    setReports(comment.items);
    setTotalCount(comment?.totalCount || 0);
    setReportedStory(story);
  }, [commentId, reportedStoryId, page]);

  useEffect(() => {
    fetchReports();
  }, [fetchReports]);

  return (
    <Paper className={classes.wrap}>
      <Typography variant="h6">Report Viewer</Typography>
      <Typography className={classes.subtitle}>{`Comment number: ${commentId}`}</Typography>
      <TablePagination
        count={totalCount}
        page={page}
        rowsPerPage={RowsPerPage}
        rowsPerPageOptions={[]}
        onChangePage={handlePageChange}
        backIconButtonProps={{
          className: classes.paginationIconButton,
        }}
        nextIconButtonProps={{
          className: classes.paginationIconButton,
        }}
        classes={{
          toolbar: classes.paginationToolbar,
        }}
      />
      <TableContainer component={'div'} className={classes.tableWrap}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>#</TableCell>
              <TableCell>Reason</TableCell>
              <TableCell>Reporter</TableCell>
              <TableCell>Reported at</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {reports.map(r => {
              const id = r.id;
              const isReportedStoryWriter = r.reporter?.id === reportedStory?.writerId;

              return (
                <TableRow key={id} hover className={classes.contentRow}>
                  <TableCell>{id}</TableCell>
                  <TableCell style={{ width: 300 }}>{r.reason}</TableCell>
                  <TableCell>
                    <CommentUser
                      userId={r.reporterId}
                      displayName={isReportedStoryWriter ? r.reporter?.displayName : undefined}
                      isWriter={isReportedStoryWriter}
                    />
                  </TableCell>
                  <TableCell className={classes.contentDesc2}>{moment(r.createdAt).format('ll HH:mm:ss')}</TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <Box className={classes.buttonWrap}>
        <Button
          variant="contained"
          color="primary"
          onClick={onClose}
          style={{
            textTransform: 'uppercase',
          }}
        >
          Close
        </Button>
      </Box>
    </Paper>
  );
};

export default ReportViewer;
